import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {getTotalPrice} from "../../../../misc/helpers";
import {isCafeCountetops} from "../../../../misc/fabricatorHardcode";

function LockedPrice() {
  return null;
}

const GroheCartDeliveryColumn = (props) => {

  const {pricingIsLocked, fabricatorSettings} = props;
  let {totalDeliveryCost} = props;

  if (!fabricatorSettings.useShipping && !isCafeCountetops) {
    return null
  }

  if (!Number.isInteger(totalDeliveryCost)) {
    totalDeliveryCost = getTotalPrice().totalDeliveryCost;
  }

  return (
    <div className="gc-footer__item">
      <span className="gc-footer__item-title">
        <FormattedMessage id="grohe.cart.confirm.columns.delivery"/>
      </span>
      <div className="gc-footer__item-value">
        {pricingIsLocked ? <LockedPrice/>  : fabricatorSettings.currencySign + totalDeliveryCost.toFixed(2)}
      </div>
    </div>
  )
};

GroheCartDeliveryColumn.propTypes = {
  pricingIsLocked: PropTypes.bool,
  totalDeliveryCost: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {settings} = store.fabricatorState;

  return {
    fabricatorSettings: settings,
  };
};

export default connect(mapStateToProps)(GroheCartDeliveryColumn)
